export default "__VITE_PUBLIC_ASSET__e8d6660e__"